import { render, staticRenderFns } from "./ActResumoPedido.vue?vue&type=template&id=13d2d9ae&scoped=true&"
import script from "./ActResumoPedido.vue?vue&type=script&lang=js&"
export * from "./ActResumoPedido.vue?vue&type=script&lang=js&"
import style0 from "./ActResumoPedido.vue?vue&type=style&index=0&id=13d2d9ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d2d9ae",
  null
  
)

export default component.exports